/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {navigate, ResponseData} from '@dvrd/dvr-controls';
import React, {useState} from 'react';
import {useParams} from 'react-router';
import {resetTwoFactor} from '../../../util/requestSender';
import {createErrorMessage, onNavigate} from '../../../util/utils';
import ResetTwoFactor from './resetTwoFactor';
import {showDialog} from '@dvrd/dvr-controls';
import {useTranslation} from 'react-i18next';

export default function ResetTwoFactorController() {
    const {t} = useTranslation();
    const [confirmed, setConfirmed] = useState(false);
    const [loading, setLoading] = useState(false);
    const {token} = useParams<{token: string}>();

    if (!token) {
        navigate('/inloggen');
        return null;
    }

    function onChangeConfirmed() {
        setConfirmed(!confirmed);
    }

    function onSubmit() {
        if (!token) return;
        setLoading(true);
        resetTwoFactor({
            token,
            callback: (data: ResponseData) => {
                if (data.success)
                    showDialog(
                        t(
                            'twoFactor.reset.successMessage',
                            'De tweestapsverificatie is succesvol uitgeschakeld, je kunt nu inloggen met jouw e-mailadres en wachtwoord.'
                        ),
                        t('twoFactor.reset.successTitle', 'Tweestapsverificatie uitgeschakeld'),
                        [
                            {
                                label: t('twoFactor.reset.okButton', 'Oké'),
                                onClick: onNavigate('/inloggen')
                            }
                        ]
                    );
                else
                    showDialog(
                        createErrorMessage(
                            data.message ??
                                t(
                                    'twoFactor.reset.failedMessage',
                                    'Het uitschakelen van de tweestapsverificatie is mislukt.'
                                )
                        ),
                        t('twoFactor.reset.failedTitle', 'Uitschakelen mislukt')
                    );
            }
        });
    }

    return (
        <ResetTwoFactor
            onChangeConfirmed={onChangeConfirmed}
            onSubmit={onSubmit}
            confirmed={confirmed}
            loading={loading}
        />
    );
}
